import states from './states.json'

export default {
	functional: true,
	props: {
		value: {},
		abbrev: {
			type: Boolean,
			default: true
		}
	},
	render (h, ctx) {
		const valueProp = (ctx.props.abbrev) ? 'abbreviation' : 'name'
		ctx.data.on = {
			input (e) {
				ctx.listeners.input(e.target.value)
			}
		}
		return (
			<select {...ctx.data}>
				<option value="">Select a state</option>
				{states.map((state, idx) => {
					const value = state[valueProp]
					return (
						<option value={value} key={idx} selected={value === ctx.props.value}>{state.name}</option>
					)
				})}
			</select>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/USStatesSelect/index.js